import { render, staticRenderFns } from "./DinarSetting.vue?vue&type=template&id=ed1ea1b4&scoped=true"
import script from "./DinarSetting.vue?vue&type=script&lang=js"
export * from "./DinarSetting.vue?vue&type=script&lang=js"
import style0 from "./DinarSetting.vue?vue&type=style&index=0&id=ed1ea1b4&prod&scoped=true&lang=css"
import style1 from "./DinarSetting.vue?vue&type=style&index=1&id=ed1ea1b4&prod&lang=css"
import style2 from "spinkit/scss/spinkit.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1ea1b4",
  null
  
)

export default component.exports